module.exports = __webpack_public_path__ + "static/data-collection-3012cf68d56af1daaba80e4eb0c629ec.jpg";